import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SimplePagination = ({ count = 1, pageSize = 50, page = 1, setPage }) => {
    const { t } = useTranslation();
    const first = (page - 1) * pageSize + 1;
    const last = Math.min(page * pageSize, count);

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="bodyMedium" color="GrayText">
                {first}-{last} {t('controls:common:of')} {count}
            </Typography>
            <IconButton onClick={() => setPage(page - 1)} disabled={page === 1}>
                <ChevronLeftRounded />
            </IconButton>
            <IconButton
                onClick={() => setPage(page + 1)}
                disabled={page * pageSize >= count}
            >
                <ChevronRightRounded />
            </IconButton>
        </Stack>
    );
};

export default SimplePagination;
